export const canceledLateHeaders = [
  {
    value: 'person.id',
    label: 'Tymber',
    sortable: false,
  },
  {
    value: 'shift.name',
    label: 'Směna',
    sortable: false,
  },
  {
    value: 'shift.start_time',
    label: 'Datum směny',
    sortable: true,
  },
  {
    value: 'updated_at',
    label: 'Datum zrušení',
    sortable: true,
  },
  {
    value: 'bonusActions',
    label: '',
    sortable: false,
  },
];
